import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Card, Upload, Button, message, Alert } from 'antd'
import { UploadOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { assignmentApi } from '../../api/auth'

export default function AssignmentSubmit() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [file, setFile] = useState<File | null>(null)
  const [loading, setLoading] = useState(false)

  const handleUpload = (info: any) => {
    const { file } = info
    if (file.status === 'done' || file) {
      setFile(file.originFileObj || file)
    }
  }

  const handleSubmit = async () => {
    if (!file) {
      message.warning('请先上传文件')
      return
    }

    setLoading(true)
    try {
      const formData = new FormData()
      formData.append('file', file)

      await assignmentApi.submit(Number(id), formData)
      message.success('提交成功,正在自动评分...')
      navigate('/assignments')
    } catch (error) {
      message.error('提交失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title="提交作业">
      <Alert
        message="提交说明"
        description="请下载题目模板文件,完成操作后上传您的Excel文件。系统将自动进行评分。"
        type="info"
        showIcon
        style={{ marginBottom: 24 }}
      />

      <Upload
        accept=".xlsx,.xls"
        beforeUpload={() => false}
        onChange={handleUpload}
        maxCount={1}
      >
        <Button icon={<UploadOutlined />}>选择Excel文件</Button>
      </Upload>

      {file && (
        <div style={{ marginTop: 16 }}>
          <p>已选择文件: {file.name}</p>
          <Button
            type="primary"
            icon={<CheckCircleOutlined />}
            onClick={handleSubmit}
            loading={loading}
          >
            提交并评分
          </Button>
        </div>
      )}
    </Card>
  )
}
